export var generateUuid = function (len, radix) {
    if (len === void 0) { len = 18; }
    if (radix === void 0) { radix = 8; }
    var CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    var uuid = function (len, radix) {
        var chars = CHARS;
        var uuid = [];
        var i;
        radix = radix || chars.length;
        if (len) {
            for (i = 0; i < len; i++)
                uuid[i] = chars[0 | (Math.random() * radix)];
        }
        else {
            var r = void 0;
            // eslint-disable-next-line no-multi-assign
            uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
            uuid[14] = '4';
            for (i = 0; i < 36; i++) {
                if (!uuid[i]) {
                    r = 0 | (Math.random() * 16);
                    uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
                }
            }
        }
        return uuid.join('') + "_" + new Date().getTime();
    };
    return uuid(len, radix);
};
